import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '赛事分类', href: '/category/football' },
    { label: '体育资讯', href: '/category/football' },
    { label: '关于我们', href: '/about' },
  ];

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  const handleNavClick = (href: string) => {
    navigate(href);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18 max-w-7xl mx-auto">
          <a
            href="/"
            onClick={(e) => { e.preventDefault(); handleNavClick('/'); }}
            className="flex items-center gap-2 flex-shrink-0 cursor-pointer"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-fire-line text-lg md:text-xl text-background-50"></i>
            </div>
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-wide whitespace-nowrap ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}>
              kaiyun体育
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className={`relative px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  isActive(link.href)
                    ? scrolled
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-background-50 bg-white/15'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-background-50/85 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => handleNavClick('/about')}
              className={`text-sm font-medium px-5 py-2 rounded-full border cursor-pointer whitespace-nowrap transition-all duration-200 ${
                scrolled
                  ? 'border-foreground-300 text-foreground-700 hover:border-foreground-500 hover:text-foreground-950'
                  : 'border-background-50/40 text-background-50 hover:border-background-50 hover:bg-white/10'
              }`}
            >
              登录
            </button>
            <button
              onClick={() => handleNavClick('/about')}
              className="text-sm font-medium px-5 py-2 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-all duration-200"
            >
              注册
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              scrolled ? 'text-foreground-950 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  isActive(link.href)
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </a>
            ))}
            <div className="flex gap-3 pt-3 px-4">
              <button
                onClick={() => handleNavClick('/about')}
                className="flex-1 text-sm font-medium px-4 py-3 rounded-full border border-foreground-300 text-foreground-700 hover:border-foreground-500 cursor-pointer whitespace-nowrap text-center transition-all"
              >
                登录
              </button>
              <button
                onClick={() => handleNavClick('/about')}
                className="flex-1 text-sm font-medium px-4 py-3 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap text-center transition-all"
              >
                注册
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}